<template>
  <div class="w1200">
    <div class="columnlistBox">
      <div v-for="(item,index) in columnlist" :key="index" class="column_li" >
        <lisTemplate1 :list="item" />
      </div>
    </div>
  </div>
</template>
<script>
import lisTemplate1 from '@/components/centerlist_home/listTemplate1/index.vue'
export default {
  components: { lisTemplate1 },
  props: ['columnlist'],
  data() {
    return {
    }
  }

}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .columnlistBox{
    font-size: 0;
    text-align: left;
    background-color: #FAFAFA;
    .column_li{
        display: inline-block;
        margin-right: 33px;
        margin-top: 20px;
        width: 275px;
        height: 278px;
      transition: 0.3s;
      &:hover{
        transform: translate(0,-3px);
      }

    }
    .column_li:nth-child(4n){
     margin-right: 0;
    }
  }
</style>

<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px){
    .columnlistBox{
      margin-top: 0;
      padding: 0 20px;
      background-color: #fff;
      .column_li{
        width: 100%;
        height: auto;
        border-bottom: 1px solid #eee;
      }
    }
  }
</style>
